module.exports = __webpack_public_path__ + "static/media/sassy.8eb6381c.png";